import { loadScript } from '../utils/loadScript';
import { sdkLoggerInterface as log } from '../Logger/Logger';
/**
 * [[include:packages/consumer/sdk-browser/src/DataSecurityMgr/README.md]]
 */
class DataSecurityMgr {
    /**
     *
     * @param libraryUrl The URL used to add the script tag to the html dom.
     * @param {TCONFIG = any} config Pass in configs to override the configs need to change how the fraud libraries
     */
    constructor(libraryUrl, config) {
        this.LibraryUrl = libraryUrl;
        this.config = config;
    }
    async loadLibrary() {
        try {
            if (this.LibraryUrl) {
                await loadScript(this.LibraryUrl, document.head);
                return true;
            }
            log.warn('No library provided');
            return false;
        }
        catch (e) {
            log.warn('Invalid or unreachable library Url provided');
            return false;
        }
    }
    /**
     * Can be overridden to show the support for context setting.
     * If no context needs to be set then return false.
     */
    setContext(context) {
        log.warn('Context setting is not supported by this library');
        return false;
    }
}
export { DataSecurityMgr };
//# sourceMappingURL=DataSecurityMgr.js.map